import React from 'react';
import { Target, Users, Eye, MousePointerClick, Star } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function MetaAdsCard() {
  const {
    t
  } = useLanguage();
  const funnel = [{
    width: 'w-full',
    bg: 'bg-blue-900/40',
    icon: Users,
    title: t.ads_row1_title,
    sub: t.ads_row1_sub,
    titleColor: 'text-white/50'
  }, {
    width: 'w-4/5 mx-auto',
    bg: 'bg-purple-900/40',
    icon: Eye,
    title: t.ads_row2_title,
    sub: t.ads_row2_sub,
    titleColor: 'text-white/50'
  }, {
    width: 'w-3/5 mx-auto',
    bg: 'bg-cyan-900/40',
    icon: MousePointerClick,
    title: t.ads_row3_title,
    sub: t.ads_row3_sub,
    titleColor: 'text-white/50'
  }, {
    width: 'w-2/5 mx-auto',
    bg: 'bg-yellow-900/40',
    icon: Star,
    title: t.ads_row4_title,
    sub: t.ads_row4_sub,
    titleColor: 'text-yellow-400 font-bold'
  }];
  const doItems = [t.ads_do1, t.ads_do2, t.ads_do3, t.ads_do4];
  return <div className="bg-kinetic-card border border-white/[0.08] rounded-xl p-5 sm:p-8 hover:border-kinetic-yellow/40 transition-colors duration-300 overflow-hidden" data-id="element-134" data-mp="pf0pv94oeb7q">
      <Target className="w-8 h-8 sm:w-10 sm:h-10 text-kinetic-yellow" data-id="element-135" data-mp="31ckoubglaj9j" />
      <span className="block text-xs text-kinetic-yellow uppercase tracking-wide mt-5 sm:mt-6" data-id="element-136" data-mp="2xc0o6xwt4xin">
        {t.ads_tag}
      </span>
      <h3 className="text-xl sm:text-2xl font-bold text-white mt-2" data-id="element-137" data-mp="3b474cjzyn4i3">{t.ads_title}</h3>
      <p className="text-white/60 text-sm mt-3 leading-relaxed" data-id="element-138" data-mp="369uglxrgb70j">{t.ads_description}</p>

      {/* Visual funnel */}
      <div className="space-y-2 mt-5 sm:mt-6" data-id="element-139" data-mp="3l2eiyw6s1agx">
        {funnel.map(row => <div key={row.title} className={`${row.width} ${row.bg} rounded-lg p-2 sm:p-3 text-center`} data-id="element-140" data-mp="3g0p9hkz7d4uy">
            <row.icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white/60 mx-auto mb-1" data-id="element-141" data-mp="3u06zu4s5cq6f" />
            <span className={`text-[10px] sm:text-xs ${row.titleColor} block`} data-id="element-142" data-mp="3p2ey6j1p9pp1">{row.title}</span>
            <span className="text-[10px] sm:text-xs text-white/30 block" data-id="element-143" data-mp="1znh5jlxv9eyi">{row.sub}</span>
          </div>)}
      </div>
      <p className="text-center text-[10px] sm:text-xs text-white/25 mt-2" data-id="element-144" data-mp="1upywzwnrh1r1">
        {t.ads_funnel_caption}
      </p>

      <div className="space-y-2 mt-5 sm:mt-6" data-id="element-145" data-mp="3jsywxchqoe5">
        {doItems.map(item => <div key={item} className="flex items-start gap-3" data-id="element-146" data-mp="3lnj29fxuch6">
            <span className="text-cyan-400 shrink-0" data-id="element-147" data-mp="8i47z5uyouvb">●</span>
            <span className="text-white/60 text-sm" data-id="element-148" data-mp="ck90205rhjfu">{item}</span>
          </div>)}
      </div>

      <div className="bg-cyan-950/30 border border-cyan-500/20 rounded-lg p-3 sm:p-4 mt-5 sm:mt-6" data-id="element-149" data-mp="hjvdoapi51p6">
        <p className="text-white/70 text-sm" data-id="element-150" data-mp="mi56ienr7q7m">{t.ads_promise}</p>
      </div>

      <a href="#consulta" className="inline-block text-kinetic-yellow text-sm mt-5 sm:mt-6 hover:text-yellow-300 transition-colors" data-id="element-151" data-mp="mgc1f3sshe1q">
        {t.ads_cta}
      </a>
    </div>;
}